export default function floatize(value = '') {
  return String(value).replace(/,/g, '.');
}
